import React, { useEffect, useState, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { PageHeader } from "@excoleadershipui/pionweblib";
import { Link, useLocation } from "react-router-dom";
import axios from "axios"
//routes
import { ASSESSMENT_BASE_URL } from "../../utils/config";
import { BATCH_REPORT_ASSESSMENT_BY_ID, BATCH_REPORT_ASSESSMENT_BY_ID_DETAILS } from "../../utils/routes";

// material ui
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
  Paper,
  Chip,
  Box,
  Grid,
  Badge,
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Stack,
  TableContainer,
  TableSortLabel,
  useMediaQuery,
  useTheme,
  Checkbox
} from "@mui/material";
// icons
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import TablePagination from "@mui/material/TablePagination";

import Tooltip from "@mui/material/Tooltip";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import SettingsIcon from "@mui/icons-material/Settings";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import FilterListIcon from "@mui/icons-material/FilterList";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import SummarizeIcon from "@mui/icons-material/Summarize";
import CloseIcon from "@mui/icons-material/Close";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { Virtuoso } from "react-virtuoso";
// components
import Layout from "../../layout/Layout";
import {
  MuiDataGrid,
  GridCellExpand,
  FormTextField as MyTextInput,
  Notifier,
  ErrorNotifier,
  MuiAutocomplete,
  MuiTooltip,
  CommonCurdPopUp
} from "../../components";
import { getFormattedDate } from "../../components/common/dataValidation";
import { HeaderDropDown } from "../../components/common/HeaderDropdown";
// redux
import {
  getAssessmentTemplate,
  getReportListById,

} from "../../features/prepare_assessments/prepareAssessmentSlice";
import { getCustomer } from "../../features/customer/customerSlice";
import { getassessmentType, setAssessmentType } from "../../features/config/assessmentTypeSlice";
import { getBatchNonPublishAssessment, getBatchPublishAssessmentById, assessorRowSelect, getBatchPublishAssessment } from "../../features/config_and_publish/publishAssessmentSlice";
import { getAccountById } from "../../features/customer/accountSlice";

// -------------------------------------------------------------------------

const style = {
  position: "absolute",
  top: "50%",
  left: "60%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  borderRadius: "5px",
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
};

// ------------------------------------------------------------------------

const AnalyzeAndReport = (props) => {
  // const [assessmentType, setAssessmentType] = useState(null)
  const [selectedRows, setSelectedRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedCustValue, setSelectedCustValue] = useState(null)
  const [assessmentBatch, setAssessmentBatch] = useState(null)
  const [showAssessor, setShowAssessor] = useState(false)
  const [selectedAccountValue, setSelectedAccountValue] = useState(null)
  const [sortField, setSortField] = useState("groupName");
  const [sortOrder, setSortOrder] = useState("asc");
  const [customer, setCustomer] = useState(null)
  const [account, setAccount] = useState(null)
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const dispatch = useDispatch();

  const location = useLocation();
  console.log("locationo", location)
  const { message, errMessage, assessmentTemplateData } = useSelector(
    (state) => ({ ...state.prepareAssessment })
  );
  const { batchAssessmentData, nonPublishAssessmentData, assessorSelectedData, selectedData, batchAssessmentListViewData, publishAssessmentData, loading } =
    useSelector((state) => ({ ...state.publishAssessment }));
  const { accountData, accountIdData } = useSelector((state) => ({ ...state?.account }));
  const { customersData } =
    useSelector((state) => ({ ...state.customer }));

  const { selectedAccountDataList, selectedCustomerDataList } = useSelector((state) => ({ ...state?.account }));
  const { assessmentTypeData, assessmentType } = useSelector((state) => ({
    ...state.assessmentTypeConfig,
  }));

  const theme = useTheme();
  const isLaptopAndAbove = useMediaQuery(
    theme.breakpoints.up("md")
  );
  const isNotLaptop = !isLaptopAndAbove;
  console.log(isNotLaptop)


  function renderCellExpand(params) {
    return (
      <GridCellExpand
        value={params.value || ""}
        width={params.colDef.computedWidth}
      />
    );
  }

  const data = {
    rows: assessorSelectedData?.assessors?.length > 0 ? assessorSelectedData?.assessors.map((data, index) => ({
      ...data,
      id: index + 1,
    })) : [],
    columns: [
      {
        field: "assessorName",
        headerName: "Assessor Name",
        width: 250,

        // valueGetter: getClient,
      },
      {
        field: "assessorEmail",
        headerName: "Assessor E-Mail",
        width: 250,
        // renderCell: getClientEmail,
        // valueGetter: (params) => params?.row?.assessmentCustomerUser?.email,
      },
      { field: "relationshipType", headerName: "Relationship", width: 150 },

      {
        field: "responseStatuscomments",
        headerName: "Comments",
        width: 350,
        // renderCell: renderCellExpand,
      },
    ],
  };

  const handleDownload = async (type) => {
    try {


      const response = await axios.post(
        type === "full"
          ? BATCH_REPORT_ASSESSMENT_BY_ID_DETAILS
          : BATCH_REPORT_ASSESSMENT_BY_ID,
        {
          assessmentTrackingIds: selectedRows,
        },
        {
          withCredentials: true,
          responseType: "blob",
        }
      );

      // Default filename
      let fileName = type === "full" ? "ELI_Detailed_Reports.zip" : "ELI_Basic_Reports.zip";

      // Read filename only if the header is accessible
      const disposition = response.headers?.["content-disposition"];

      if (disposition) {
        const match = disposition.match(/filename="?([^"]+)"?/);
        if (match?.[1]) {
          fileName = match[1];
        }
      }

      const blobUrl = window.URL.createObjectURL(response.data);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = fileName;
      
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  function AssessmentTable({ batch, assessments }) {



    // useEffect(() => {
    //   if (assessments?.length) {
    //     setSelectedRows(
    //      assessments.map(item => item.assessmentTrackingId)
    //     );
    //   }
    // }, []);

    const columns = [
      { field: "assessmentName", header: "Assessment Name", width: 250 },
      { field: "clientName", header: "Client Name", width: 200 },
      { field: "clientEmail", header: "Client Email", width: 200 },
      { field: "cutOffDate", header: "Cut Off Date", width: 150 },
      { field: "settings", header: "Assessors", width: 80 },

      // { field: "status", header: "Status", width: 120 },
      // { field: "action", header: "Action", width: 200 },
      { field: "customerName", header: "Customer Name", width: 200 },
      { field: "accountName", header: "Account Name", width: 200 },
      { field: "assessmentType", header: "Assessment Type", width: 200 },
    ];

    const totalColumnWidth = columns.reduce((sum, col) => sum + col.width, 0);

    const handleSelectAll = (event) => {
      if (event.target.checked) {
        setSelectedRows(assessments.map((item) => item.assessmentTrackingId));
      } else {
        setSelectedRows([]);
      }
    };

    const handleRowSelect = (id) => {
      setSelectedRows((prev) =>
        prev.includes(id)
          ? prev.filter((rowId) => rowId !== id)
          : [...prev, id]
      );
    };


    return (

      <TableContainer
        component={Paper}
        sx={{
          width: "100%",
          overflowX: "auto",
          border: "1px solid #E5E7EB",
          borderRadius: "8px",
        }}
      >
        <Table
          size="small"
          size="small"
          sx={{
            width: "100%",
            minWidth: totalColumnWidth,
          }}
        >
          <TableHead>
            <TableRow
              sx={{
                backgroundColor: "#E5E7EB",
                "& th": {
                  fontWeight: 600,
                  color: "#374151",
                  borderBottom: "1px solid #D1D5DB",
                  whiteSpace: "nowrap",
                },
              }}
            >
              <TableCell padding="checkbox">
                <Checkbox
                  checked={
                    assessments.length > 0 &&
                    selectedRows.length === assessments.length
                  }
                  indeterminate={
                    selectedRows.length > 0 &&
                    selectedRows.length < assessments.length
                  }
                  onChange={handleSelectAll}
                />
              </TableCell>

              {columns.map((column) => (
                <TableCell
                  key={column.field}
                  sx={{
                    width: `${100 / columns.length}%`,
                    minWidth: column.width,
                  }}
                >
                  {column.header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {assessments.map((item, index) =>
              item?.assessmentType === assessmentType?.assessmentType ?

                (
                  <TableRow
                    key={item.assessmentTrackingId}
                    hover
                    selected={selectedRows.includes(item.assessmentTrackingId)}
                    sx={{
                      backgroundColor: "#F9FAFB",
                      "&:hover": {
                        backgroundColor: "#F3F4F6",
                      },
                      "& td": {
                        borderBottom: "1px solid #E5E7EB",
                      },
                    }}
                  >
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={selectedRows.includes(item.assessmentTrackingId)}
                        onChange={() => handleRowSelect(item.assessmentTrackingId)}
                      />
                    </TableCell>

                    <TableCell>{item.templateName || item.assessmentTemplateName}</TableCell>

                    <TableCell>{item.clientName}</TableCell>

                    <TableCell>{item.clientEmail}</TableCell>

                    <TableCell>{getFormattedDate(item.cutOffDate)}</TableCell>

                    <TableCell>

                      <MuiTooltip title="Assessors" placement="bottom">
                        <IconButton aria-label="settings" onClick={() => {
                          setShowAssessor(true)
                          dispatch(assessorRowSelect([item]))
                        }}>
                          <SettingsIcon sx={{ color: "#808080" }} />
                        </IconButton>
                      </MuiTooltip>





                    </TableCell>

                    {/* <TableCell>{item.status}</TableCell> */}



                    <TableCell>
                      {batch?.assessmentCustomer?.customerName}
                    </TableCell>

                    <TableCell>
                      {batch?.assessmentCustomerAccount?.accountName}
                    </TableCell>

                    <TableCell>
                      {item?.assessmentType}
                    </TableCell>
                  </TableRow>
                ) : null

            )}
          </TableBody>
        </Table>
      </TableContainer>

    );
  }


  //  function AssessmentTable({ batch, assessments }) {
  //   const columns = [
  //     { field: "assessmentName", header: "Assessment Name", width: 250 },
  //     { field: "clientName", header: "Client Name", width: 200 },
  //     { field: "clientEmail", header: "Client Email", width: 200 },
  //     { field: "cutOffDate", header: "Cut Off Date", width: 150 },
  //     { field: "settings", header: "", width: 80 },
  //     { field: "status", header: "Status", width: 120 },
  //     { field: "action", header: "Action", width: 120 },
  //     { field: "customerName", header: "Customer Name", width: 200 },
  //     { field: "accountName", header: "Account Name", width: 200 },
  //     { field: "assessmentType", header: "Assessment Type", width: 200 },
  //   ];

  //   const totalColumnWidth = columns.reduce((sum, col) => sum + col.width, 0);


  //   return (

  //     <TableContainer
  //       component={Paper}
  //       sx={{
  //         width: "100%",
  //         overflowX: "auto",
  //         border: "1px solid #E5E7EB",
  //         borderRadius: "8px",
  //       }}
  //     >
  //       <Table
  //         size="small"
  //         size="small"
  //         sx={{
  //           width: "100%",
  //           minWidth: totalColumnWidth,
  //         }}
  //       >
  //         <TableHead>
  //           <TableRow
  //             sx={{
  //               backgroundColor: "#E5E7EB",
  //               "& th": {
  //                 fontWeight: 600,
  //                 color: "#374151",
  //                 borderBottom: "1px solid #D1D5DB",
  //                 whiteSpace: "nowrap",
  //               },
  //             }}
  //           >
  //             {columns.map((column) => (
  //               <TableCell
  //                 key={column.field}
  //                 sx={{
  //                   width: `${100 / columns.length}%`,
  //                   minWidth: column.width,
  //                 }}
  //               >
  //                 {column.header}
  //               </TableCell>
  //             ))}
  //           </TableRow>
  //         </TableHead>

  //         <TableBody>
  //           {assessments.map((item) => (
  //             <TableRow
  //               key={item.id}
  //               sx={{
  //                 backgroundColor: "#F9FAFB",
  //                 "&:hover": {
  //                   backgroundColor: "#F3F4F6",
  //                 },
  //                 "& td": {
  //                   borderBottom: "1px solid #E5E7EB",
  //                 },
  //               }}
  //             >
  //               <TableCell sx={{ width: columns[0].width }}>
  //                 {item.templateName || item.assessmentTemplateName}
  //               </TableCell>

  //               <TableCell sx={{ width: columns[1].width }}>
  //                 {item.clientName}
  //               </TableCell>

  //               <TableCell sx={{ width: columns[2].width }}>
  //                 {item.clientEmail}
  //               </TableCell>

  //               <TableCell sx={{ width: columns[3].width }}>
  //                 {getFormattedDate(item.cutOffDate)}
  //               </TableCell>

  //               <TableCell sx={{ width: columns[4].width }}>

  //                 <IconButton
  //                   onClick={() => {
  //                     // dispatch(assessorRowSelect([item]));
  //                     setShowAssessor(true);
  //                   }}
  //                 >
  //                   <MuiTooltip title="Assessors" placement="bottom">
  //                     <SettingsIcon sx={{ color: "#808080" }} />
  //                   </MuiTooltip>
  //                 </IconButton>
  //               </TableCell>

  //               <TableCell sx={{ width: columns[5].width }}>
  //                 {item.status}
  //               </TableCell>

  //               <TableCell sx={{ width: columns[6].width }}>
  //                 <Button
  //                   size="small"
  //                   variant="outlined"
  //                   color="error"
  //                   // onClick={() => showAssessmentDelete(batch, item)}
  //                 >
  //                   Remove
  //                 </Button>
  //               </TableCell>

  //               <TableCell sx={{ width: columns[7].width }}>
  //                 {batch?.assessmentCustomer?.customerName}
  //               </TableCell>

  //               <TableCell sx={{ width: columns[8].width }}>
  //                 {batch?.assessmentCustomerAccount?.accountName}
  //               </TableCell>

  //               <TableCell sx={{ width: columns[9].width }}>
  //                 ELI Assessment
  //               </TableCell>
  //             </TableRow>
  //           ))}
  //         </TableBody>
  //       </Table>
  //     </TableContainer>

  //   );
  // } 
  const [expandedRows, setExpandedRows] = useState([]);


  const toggleExpand = (id) => {
    setExpandedRows((prev) =>
      prev.includes(id)
        ? prev.filter((x) => x !== id)
        : [...prev, id]
    );
  };

  const dataAssessor = {
    rows: assessorSelectedData?.assessors?.length > 0 ? assessorSelectedData?.assessors.map((data, index) => ({
      ...data,
      id: index + 1,
    })) : [],
    columns: [
      {
        field: "assessorName",
        headerName: "Assessor Name",
        width: 250,

        // valueGetter: getClient,
      },
      {
        field: "assessorEmail",
        headerName: "Assessor E-Mail",
        width: 250,
        // renderCell: getClientEmail,
        // valueGetter: (params) => params?.row?.assessmentCustomerUser?.email,
      },
      { field: "relationshipType", headerName: "Relationship", width: 150 },

      {
        field: "responseStatuscomments",
        headerName: "Comments",
        width: 350,
        // renderCell: renderCellExpand,
      },
    ],
  };

  const handleClear = () => {
    setCustomer("");
    setAccount("");

    dispatch(getBatchPublishAssessmentById())
    // setAssessmentType("");
  };



  // separate dropdown data and list view data

  const sortedGroups = useMemo(() => {
    const data = Array.isArray(batchAssessmentData?.data)
      ? batchAssessmentData.data
      : typeof batchAssessmentData?.data === "object"
        ? [batchAssessmentData.data]
        : [];

    let finalSortedData = [...data].filter((dataFil) => dataFil.status === "Published").sort((a, b) => {
      const valueA = a[sortField];
      const valueB = b[sortField];

      return sortOrder === "asc"
        ? String(valueA ?? "").localeCompare(String(valueB ?? ""))
        : String(valueB ?? "").localeCompare(String(valueA ?? ""));
    });

    setSelectedRows(
      finalSortedData?.[0]?.assessments?.map(
        (item) => item.assessmentTrackingId
      ) || []
    );

    return finalSortedData
  }, [batchAssessmentData?.data, sortField, sortOrder]);

  console.log(sortedGroups)

  const paginatedGroups = sortedGroups.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );


  const columnWidths = {
    expand: 60,
    batchName: "25%",
    assessments: "15%",
    summary: "15%",
    assessmentType: "20%",
    status: 120,
    delete: 40,
    edit: 40,
  };

  const columns = [
    {
      field: "expand",
      label: "",
      width: 60,
      sortable: false,
    },
    {
      field: "groupName",
      label: "Batch Name",
      width: "25%",
      sortable: true,
    },
    {
      field: "assessments",
      label: "Assessments",
      width: "15%",
      sortable: true,
    },
    // {
    //   field: "summary",
    //   label: "Summary",
    //   width: "15%",
    //   sortable: true,
    // },
    {
      field: "status",
      label: "Status",
      width: 120,
      sortable: true,
    },
    {
      field: "delete",
      label: assessmentBatch ? "Reports" : "",
      width: assessmentBatch ? 40 : 0,
      sortable: false,
    },
    {
      field: "edit",
      label: "",
      width: assessmentBatch ? 40 : 0,
      sortable: false,
    },
    {
      field: "customerName",
      label: "Customer Name",
      width: "20%",
      sortable: true,
    },
    {
      field: "accountName",
      label: "Account Name",
      width: "20%",
      sortable: true,
    },
  ];

  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
    } else {
      setSortField(field);
      setSortOrder("asc");
    }
  };


  useEffect(() => {
    // dispatch(getAssessmentTemplate());
    dispatch(getBatchNonPublishAssessment())
    dispatch(getBatchPublishAssessmentById())
    dispatch(getCustomer())
    dispatch(getassessmentType())
  }, []);



  // useEffect(() => {
  //   dispatch(setAssessmentType(assessmentTypeData?.find((data) => data.code === "ELI")));
  // }, [assessmentTypeData])

  useEffect(() => {
    // if assessment type is selected no need to call this use effect then the state variable it wont change so that time 
    // you will get the state variable stored and it will not be resetted everytime
    if (!assessmentType && assessmentTypeData?.length > 0) {
      const defaultType = assessmentTypeData.find(
        (data) => data.code === "ELI"
      );

      if (defaultType) {
        dispatch(setAssessmentType(defaultType));

      }
    }
  }, [assessmentTypeData]);
  const getCustomerSelectedValue = (data) => {
    // formik.setFieldValue("custName", data)
    setSelectedCustValue(data)
  }

  const getAccountSelectedValue = (data) => {
    // formik.setFieldValue("account", data)
    setSelectedAccountValue(data)
  }

  console.log(selectedRows)

  return (
    <>
      <>
        {/* <PageHeader variant="pageHeader">Assessment Response Report</PageHeader> */}

        <Box >
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={3.1} sx={{ mb: 1 }}>
              <MuiAutocomplete
                name="assessmentBatch"
                options={batchAssessmentListViewData?.data ? batchAssessmentListViewData?.data : []}
                setValue={(name, newValue) => {
                  setAssessmentBatch(newValue)
                  setSelectedRows([])
                  if (newValue) {
                    dispatch(getBatchPublishAssessment({ id: newValue?.id }))
                  }
                  else {
                    dispatch(getBatchPublishAssessmentById())
                  }
                  setExpandedRows([])

                }}
                value={assessmentBatch}
                size="small"
                height="100%"
                fullWidth={true}
                noMargin
                optionValue="name"
                // optionSecValue="code"
                label="Select or Search Batch"
              />
            </Grid>



            <Grid item pb={0.8}>
              <Tooltip
                arrow
                componentsProps={{ tooltip: { sx: { bgcolor: "#FFFFFF", color: "#000000", border: "1px solid #D9E2EC", boxShadow: "0px 4px 12px rgba(0,0,0,0.12)", maxWidth: 350, p: 2, }, }, arrow: { sx: { color: "#FFFFFF", }, }, }}
                placement="bottom-start"
                title={
                  <>
                    <Typography variant="subtitle2" fontWeight={600}>
                      Select a batch from the Batch dropdown filter to enable the Basic Report and Detailed Report download buttons.
                    </Typography>


                  </>
                }
              >
                <InfoOutlinedIcon
                  color="primary"
                  sx={{

                    fontSize: 25,

                    cursor: "pointer",
                    marginTop: "1rem"
                  }}
                />
              </Tooltip>
            </Grid>

            <Grid item xs />



            <Grid item>
              <IconButton aria-label="filter-list" sx={{}} onClick={() => setOpen(true)}>
                <Badge badgeContent={(customer ? 1 : 0) +
                  (account ? 1 : 0)} color="primary">
                  <MuiTooltip title="Filters" placement="bottom">
                    <FilterListIcon fontSize="1rem" />
                  </MuiTooltip>
                </Badge>
              </IconButton>

            </Grid>

            <Grid item xs={12} md={3.1} sx={{ mb: 1 }}>
              <MuiAutocomplete
                name="assessmentType"
                options={assessmentTypeData}
                setValue={(name, newValue) => dispatch(setAssessmentType(newValue))}
                value={assessmentType}
                size="small"
                height="100%"
                fullWidth={true}
                noMargin
                optionValue={"assessmentType"}
                // optionSecValue="code"
                label={"Assessment Type"}
              />
            </Grid>
          </Grid>
        </Box>
        {/* <HeaderDropDown
          isBatch={true}
          sx={{ marginTop: "1rem" }}
          heading="Assessment Response Report"
          assessmentTypeData={assessmentTypeData}
          batchAssessmentListViewData={batchAssessmentListViewData}
          assessmentType={assessmentType}
          assessmentBatch={assessmentBatch}
          setAssessmentBatch={(value) => {
            setAssessmentBatch(value)
            if (value) {
              dispatch(getBatchPublishAssessment({ id: value?.id }))
            }
            else {
              dispatch(getBatchPublishAssessmentById())
            }
          }}
          setAssessmentType={(value) => dispatch(setAssessmentType(value))}
        /> */}
        <Box
          sx={{
            width: "100%",
            overflowX: isNotLaptop ? "auto" : undefined,
          }}
        >
          <Box
            sx={{
              width: "100%",
              ...(isNotLaptop && {
                minWidth: 1200,
              }),
            }}
          >
            <Table
              sx={{

                tableLayout: "fixed",
              }}
            >
              <TableHead
                sx={{
                  border: "1px solid #D9E2EC",
                  borderBottom: "none",
                  borderRadius: "6px 6px 0 0",
                  overflow: "hidden",
                }}
              >
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.field}
                      sx={{
                        width: column.width,
                        cursor: column.sortable ? "pointer" : "default",
                        fontWeight: 600,
                      }}
                      onClick={() =>
                        column.sortable && handleSort(column.field)
                      }
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 0.5,
                        }}
                      >
                        {column.label}

                        {column.sortable &&
                          sortField === column.field &&
                          (sortOrder === "asc" ? (
                            <ArrowUpwardIcon
                              sx={{
                                color: "#9CA3AF", // Grey
                                fontSize: 20,
                              }}
                            />
                          ) : (
                            <ArrowDownwardIcon
                              sx={{
                                color: "#9CA3AF", // Grey
                                fontSize: 20,
                              }}
                            />
                          ))}
                      </Box>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
            </Table>


            <Virtuoso
              style={{
                height: 400,
                border: "1px solid #D9E2EC",
                borderTop: "none", // Connects nicely with your header
                borderRadius: "0 0 6px 6px",
                overflowX: "auto",

              }}
              totalCount={sortedGroups.length}
              itemContent={(index) => {
                const group = sortedGroups[index];
                const expanded = expandedRows?.includes(group?.id);

                return (
                  <>
                    <Table
                      sx={{
                        tableLayout: "fixed",
                        width: "100%"

                      }}
                    >
                      <TableBody>
                        <TableRow
                          sx={{
                            backgroundColor:
                              index % 2 === 0 ? "#c4e1f1" : "#FFFFFF",

                            "&:hover": {
                              backgroundColor:
                                index % 2 === 0 ? "#CFE2F3" : "#F5F9FD",
                            },

                            "& td": {
                              borderBottom: "1px solid #E5E7EB",

                              py: 0.9,      // Vertical padding (default is around 2)
                              px: 2,      // Horizontal padding
                              height: 40,   // Optional fixed height
                            },
                          }}
                        >
                          <TableCell sx={{ width: columnWidths.expand }}>
                            <IconButton
                             aria-label="keyboardarrow"
                              onClick={() => {

                                toggleExpand(group.id)
                                // setSelectedRows(
                                //   group?.assessments.map(item => item.assessmentTrackingId)
                                // );
                              }}


                            >
                              {expanded ? (
                                <KeyboardArrowDownIcon />
                              ) : (
                                <KeyboardArrowRightIcon />
                              )}
                            </IconButton>
                          </TableCell>

                          <TableCell sx={{ width: columnWidths.batchName }}>
                            {group.name}
                          </TableCell>

                          <TableCell sx={{ width: columnWidths.assessments }}>
                            {group.assessmentCount} assessments
                          </TableCell>

                          {/* <TableCell sx={{ width: columnWidths.summary }}>
                            {group?.clientMails} client mail
                            <br />
                            {group?.assessorMails} assessor mail
                          </TableCell> */}



                          <TableCell sx={{ width: columnWidths.status }}>
                            <Chip
                              label={group.status}
                              size="small"
                            />
                          </TableCell>

                          <TableCell sx={{ width: columnWidths.delete }}>
                            {assessmentBatch && group?.assessments?.length > 0 &&  <IconButton
                            aria-label="download"
                              size="small"
                              onClick={() => handleDownload("")}
                            >
                              <MuiTooltip title="Basic Reports" placement="bottom">
                                <FileDownloadIcon color="primary"
                                />
                              </MuiTooltip>
                            </IconButton>}
                          </TableCell>

                          <TableCell sx={{ width: columnWidths.edit }}>
                            {assessmentBatch  && group?.assessments?.length > 0 && <IconButton
                              aria-label="download"
                              color="error"
                              size="small"
                              onClick={() => handleDownload("full")}
                            >
                              <MuiTooltip title="Detailed Reports" placement="bottom">
                                <FileDownloadIcon color="primary" />
                              </MuiTooltip>
                            </IconButton>}
                          </TableCell>
                          <TableCell sx={{ width: columnWidths.assessmentType }}>
                            {group?.assessmentCustomer?.customerName}
                          </TableCell>

                          <TableCell sx={{ width: columnWidths.assessmentType }}>
                            {group?.assessmentCustomerAccount?.accountName}
                          </TableCell>
                        </TableRow>

                        {expanded && (
                          <TableRow>
                            <TableCell colSpan={12}>
                              <AssessmentTable
                                batch={group}
                                assessments={group?.assessments}
                              />
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table >
                  </>
                );
              }}
            />
          </Box>
        </Box>
        <TablePagination
          component="div"
          count={sortedGroups.length}
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={(e, newPage) => setPage(newPage)}
          onRowsPerPageChange={(e) => {
            setRowsPerPage(parseInt(e.target.value, 10));
            setPage(0);
          }}
          rowsPerPageOptions={[10, 25, 50]}
          sx={{
            border: "1px solid #D9E2EC",
            borderTop: "none",
            backgroundColor: "#fff",
            ".MuiTablePagination-toolbar": {
              minHeight: 52,
            },
          }}
        />

        <Dialog
          open={open}
          onClose={() => setOpen(false)}
          maxWidth="sm"
          PaperProps={{
            sx: {
              position: "fixed",
              right: "10%",
              top: "32%",
              margin: 0,
              // height: "100vh",
              width: 400, // adjust width as needed
              maxWidth: "100%",
              borderRadius: "0",
            },
          }}

        >
          {/* <DialogTitle>Filters</DialogTitle> */}

          <DialogTitle
            sx={{
              borderBottom: "1px solid #E5E7EB",
              px: 3,
              py: 2,
            }}
          >
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Stack
                direction="row"
                spacing={2}
                alignItems="center"
              >
                <FilterListIcon
                  sx={{
                    color: "#00527D",
                  }}
                />

                <Typography
                  variant="h6"
                  fontWeight={600}
                >
                  Filters
                </Typography>


              </Stack>

              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
              >
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleClear}
                >
                  Clear All
                </Button>

                <IconButton
                  aria-label="close"
                  size="small"
                  onClick={() => setOpen(false)}
                >
                  <CloseIcon />
                </IconButton>
              </Stack>
            </Stack>
          </DialogTitle>

          <DialogContent>
            <Box display="flex" flexDirection="column" gap={1} mt={1}>

              <MuiAutocomplete
                name="customer"
                options={customersData}
                setValue={
                  (name, newValue) => {
                    setCustomer(newValue)
                    setAccount(null)
                    setAssessmentBatch(null)
                    dispatch(getAccountById({ assessmentCustomerId: newValue?.id }))
                    dispatch(getBatchPublishAssessmentById({ customerId: newValue?.id }))
                  }}
                value={customer}
                size="small"
                height="100%"
                fullWidth={true}
                noMargin
                optionValue="customerName"
                // optionSecValue="code"
                label="Customer Name"
              />

              <MuiAutocomplete
                name="account"
                options={accountIdData}
                setValue={(name, newValue) => {
                  setAccount(newValue)
                  dispatch(getBatchPublishAssessmentById({ customerId: customer?.id, accountId: newValue?.id }))

                }}
                value={account}
                size="small"
                height="100%"
                fullWidth={true}
                noMargin
                optionValue="accountName"
                // optionSecValue="code"
                label="Account Name"
              />

              {/* Customer */}


              {/* Account */}


              {/* Assessment Type */}

            </Box>
          </DialogContent>


        </Dialog>

        {showAssessor && <CommonCurdPopUp
          // isDownload={true}
          // TARGET_URL={GET_ALL_STATUS_EXCEL_DOWNLOAD}
          // targetId={props?.statusTracking}
          // downloadFunc={downLoadFunc}
          heading={`Assessor Detail`}
          mediumScreen={true}
          close={() => setShowAssessor(false)}
        >
          <div
            // style={{ marginLeft: "20px", marginRight: "20px" }}
            className="res_tcTestData"
          >
            <MuiDataGrid

              data={data}
            // select={(item) => {
            //   if (item.length > 0) {
            //     setShowDetailData(item);
            //     // setShowDetail(true);
            //   }
            // }}
            />
          </div>
        </ CommonCurdPopUp>}



        {/* <MuiDataGrid
          getCallBackCustomer={(data) => getReportListById({ assessmentCustomerId: data })}
          getCallBackOne={getAssessmentTemplate}
          getCallBackTwo={(data) => getReportListById({ assessmentCustomerAccountId: data })}
          // getCallBackargs = {defaultCallBack}
          getAccountSelectedValue={(data) => getAccountSelectedValue(data)}
          getCustomerSelectedValue={(data) => getCustomerSelectedValue(data)}
          // assessmentType={assessmentType}
          isAccount={true}
          isCustomer={true}

          toolbarColumn={true}
          // toolbarFilter={true}
          toolbarDensity={true}
          toolbarExport={true}
          data={data}
        /> */}
      </>

      {errMessage && <ErrorNotifier message={errMessage} />}
      {message && <Notifier message={message} />}
    </>
  );
};

export default AnalyzeAndReport;
